import { ColorPicker } from '@/components/ColorPicker';
import { isValidHexColor } from '@/components/ColorPicker/utils/isValidHexColor';
import { removeHexColorAlphaSuffix } from '@/components/ColorPicker/utils/removeHexColorAlphaSuffix';
import { predefinedColors } from '@/pages/AdvancedEditor/components/panels/common/predefinedColors';
import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import { getAvatarElementFromPage, getAvatarGroupFromPage } from '@/pages/AdvancedEditor/utils';
import theme from '@/theme';
import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';
import { ElementType } from 'polotno/model/group-model';

const ColorPickerContainer = styled.div`
    display: flex;
    width: min-content;
    gap: 8px;
    align-items: center;
    cursor: pointer;
    border-radius: 8px;
    padding: 6px 8px;
    border: 1px solid ${theme.colors.black[200]};
`;

const InvisibleInput = styled.input`
    border: none;
    outline: none;
    width: auto;
    min-width: 0;
    flex: 0 1 auto;
    color: ${theme.colors.secondary.main};
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
`;

export const FillColorControl = observer(() => {
    const { store } = useAdvancedEditorContext();
    const avatarElement = getAvatarElementFromPage(store.activePage);

    if (!avatarElement) return null;

    const group = getAvatarGroupFromPage(store.activePage);
    const circleFillElement = group?.children.find(
        (child: ElementType) => child.type === 'figure' && child.subType === 'circle' && child.name === 'avatar-fill'
    );

    if (!circleFillElement) return null;

    const handleColorChange = (color: string) => {
        const fill = removeHexColorAlphaSuffix(color);
        circleFillElement.set({ fill });
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const input = e.target.value.replaceAll('#', '');

        if (isValidHexColor(input)) {
            handleColorChange('#' + input);
        }
    };

    return (
        <ColorPickerContainer>
            <ColorPicker value={circleFillElement.fill} onChange={handleColorChange} size="24px" predefinedColors={predefinedColors} />
            <InvisibleInput
                size={8}
                type="text"
                value={circleFillElement.fill}
                onChange={handleInputChange}
                onClick={e => e.currentTarget.select()}
            />
        </ColorPickerContainer>
    );
});
